module.exports = __webpack_public_path__ + "img/grupo-rbs.8b75985f.svg";